<div class="auth-wrapper">
  <div class="auth-card">

    <!-- Header -->
    <h2 class="title">Create New Password</h2>
    <p class="subtitle">
      Please set a new password to continue
    </p>

    <form [formGroup]="form" (ngSubmit)="submit()">

      <!-- New Password -->
      <div class="form-group">
        <label>New Password</label>
        <div class="password-wrapper">
          <input class="form-input" [type]="hideNewPassword ? 'password' : 'text'" placeholder="Enter new password"
            formControlName="newPassword" />
          <!-- Error Message -->
          @if (form.controls['newPassword'].touched &&
          form.controls['newPassword'].errors?.['required']) {
          <div class="error-text">New password is mandatory</div>
          }

          @if (form.controls['newPassword'].touched &&
          (form.controls['newPassword'].errors?.['minlength'] ||
          form.controls['newPassword'].errors?.['maxlength'])) {
          <div class="error-text">
            Password length must be between 8 and 12 characters
          </div>
          }

          @if (form.controls['newPassword'].touched &&
          form.controls['newPassword'].errors?.['pattern']) {
          <div class="error-text">
            Only allowed special characters (&#64;,$,!,%,*,?,&,#,_,-)
          </div>
          }

          <span class="eye-icon" (click)="hideNewPassword = !hideNewPassword">
            @if(!hideNewPassword) {
            <span class="eye-icon"><i class="bi bi-eye-fill"></i></span>
            } @else {
            <span class="eye-icon"><i class="bi bi-eye-slash-fill"></i></span>
            }
          </span>
        </div>
        <ul class="password-rules">
        
          <li [class.valid]="passwordRules.length">
            8 – 16 characters
          </li>
        
          <li [class.valid]="passwordRules.alphanumericOrSpecial">
            Alphanumeric with special character (&#64;,$,!,%,*,?,&,#,_,-)
          </li>
        </ul>


      </div>

      <!-- Confirm Password -->
      <div class="form-group">
        <label>Confirm Password</label>
        <div class="password-wrapper">
          <input class="form-input" [type]="hideConfirmPassword ? 'password' : 'text'"
            placeholder="Confirm new password" formControlName="confirmPassword" />

          <!-- Error Message -->
          @if (form.controls['confirmPassword'].touched &&
          form.controls['confirmPassword'].errors?.['required']) {
          <div class="error-text">Confirm password is mandatory</div>
          }

          @if (form.controls['confirmPassword'].touched &&
          (form.controls['confirmPassword'].errors?.['minlength'] ||
          form.controls['confirmPassword'].errors?.['maxlength'])) {
          <div class="error-text">
            Password length must be between 8 and 16 characters
          </div>
          }

          <span class="eye-icon" (click)="hideConfirmPassword = !hideConfirmPassword">
            @if(!hideConfirmPassword) {
            <span class="eye-icon"><i class="bi bi-eye-fill"></i></span>
            } @else {
            <span class="eye-icon"><i class="bi bi-eye-slash-fill"></i></span>
            }
          </span>
        </div>
      </div>

      <div class="error" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      @if (form.touched && form.errors?.['passwordMismatch']) {
      <div class="error-text">Passwords do not match</div>
      }

      <button class="primary-btn" type="submit" [disabled]="loading || form.invalid">
        {{ loading ? 'Updating...' : 'Update Password' }}
      </button>

    </form>
  </div>
</div>